import type {Project} from '@package/shared'
import dayjs, {type Dayjs} from 'dayjs'
import type {BarChartProps} from '@mantine/charts'
import {groupBy} from 'lodash'
import type {DayHoursByProject} from '@app/api-resolver/router'
import {mapDays} from './mapDays.ts'

export const mapBarChart = (start: Dayjs, end: Dayjs, dayHoursByProject: DayHoursByProject[], projects: Project[]) => {
  const chartItemsByDay = groupBy(dayHoursByProject, (chartItem) => dayjs(chartItem.dayStart).date())

  const data: BarChartProps['data'] = mapDays(start, end).map((day) => {
    const dayInMonth = day.date()
    const chartItems = chartItemsByDay[dayInMonth] || []
    let item = {dayInMonth, day}
    for (const chartItem of chartItems) {
      item = {...item, [chartItem.projectId]: chartItem.hours}
    }
    return item
  })

  const projectIdsWithData = new Set(dayHoursByProject.map((chartItem) => chartItem.projectId))
  const series: BarChartProps['series'] = projects
    .filter((project) => projectIdsWithData.has(project.id))
    .map((project) => ({name: project.id, label: project.name, color: project.color}))

  return {data, dataKey: 'dayInMonth', series} satisfies Pick<BarChartProps, 'data' | 'dataKey' | 'series'>
}
